module.exports = __webpack_public_path__ + "img/img15.8fedc2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img15.jpg
// module id = 280
// module chunks = 0